<div id="clickableAwesomeFont">
  <button
    class="bg-danger text-white border border-dark pe-none"
    (click)="onUpdateClick()"
  >
    Update
  </button>
</div>
